import { useState } from "react";
import DeleteAccountModal from "./DeleteAccountModal";
import "../../App.css";

export default function AccountDangerZone({ user }) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="account-card account-card--danger led--danger">
      <h3 className="account-card-title">Danger Zone</h3>
      <div className="account-danger-content">
        <p className="account-danger-label">Delete Account</p>
        <p className="danger-zone-text">Permanently delete your account and all associated data.</p>
        <button className="danger-btn" onClick={() => setModalOpen(true)}>Delete Account</button>
      </div>
      <DeleteAccountModal isOpen={modalOpen} onClose={() => setModalOpen(false)} user={user} />
    </div>
  );
}
